import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=5fa8fe37&scoped=true"
import script from "./dataAnalysis.vue?vue&type=script&lang=js"
export * from "./dataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=5fa8fe37&prod&lang=less"
import style1 from "./dataAnalysis.vue?vue&type=style&index=1&id=5fa8fe37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8fe37",
  null
  
)

export default component.exports